var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause5 = function SvgIconPause5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 38h13V0H0zm19 0h13V0H19z",
    fill: "#2B328C"
  })));
};
export default SvgIconPause5;